module.exports = __webpack_public_path__ + "static/media/arrow-up.83fd32b6.svg";